import React, { useEffect, useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import ProductSelector from '../../common/ProductSelector';
import axios from 'axios';
import config from '../../../config';
import { toast } from 'react-toastify';

function PurchaseItemsForm({ form, setForm, stepSubmitted }) {
  const [productMap, setProductMap] = useState({}); // productId => unitName

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get(`${config.API_BASE_URL}/products?populateUnit=true`);

        const map = {};
        res.data.forEach(p => {
          map[p._id] = {
            unitName: p.unitId?.unitCode || '',
            fullProduct: p,
          };
        });

        setProductMap(map);
      } catch (err) {
        console.error('Failed to load products', err);
        toast.error('Failed to load products');
      }
    };

    fetchProducts();
  }, []);

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...form.items];
    updatedItems[index][field] = value;
    setForm({ ...form, items: updatedItems });
  };

  const handleProductSelect = (index, productId) => {
    const updatedItems = [...form.items];
    // Find the product details from the map
    const productDetails = productMap[productId];
    if (productDetails) {
      updatedItems[index].product = {
        value: productId,
        label: productDetails.fullProduct.productName,
      };
      updatedItems[index].quantity_unit = productDetails.unitName;
    }

    setForm({ ...form, items: updatedItems });
  };


  const addItem = () => {
    setForm({
      ...form,
      items: [...form.items, { product: '', quality: '', approx_quantity: '', quantity_unit: '' }],
    });
  };

  const removeItem = (index) => {
    if (form.items.length <= 1) return; // Don't remove if only one item left
    const updatedItems = [...form.items];
    updatedItems.splice(index, 1);
    setForm({ ...form, items: updatedItems });
  };

  return (
    <>
      {form.items.map((item, index) => (
        <div key={index} className="border rounded mb-3 p-3 pt-2 position-relative">
          <div
            className="d-flex flex-column flex-sm-row gap-2 align-items-start align-items-sm-center flex-wrap"
            style={{ rowGap: '10px' }}
          >
            <div style={{ flex: 2, minWidth: '150px' }}>
              <Form.Group>
                <Form.Label className="mb-1">Product</Form.Label>
                <ProductSelector
                  value={item.product?.value || item.product || ''}
                  onChange={(productId) => handleProductSelect(index, productId)}
                  className={stepSubmitted && !item.product ? 'is-invalid' : ''}
                />
              </Form.Group>
            </div>

            <div style={{ flex: 1.2, minWidth: '120px' }}>
              <Form.Group>
                <Form.Label className="mb-1">Quality</Form.Label>
                <Form.Control
                  type="text"
                  value={item.quality}
                  onChange={(e) => handleItemChange(index, 'quality', e.target.value)}
                />
              </Form.Group>
            </div>

            <div style={{ flex: 1.2, minWidth: '120px', position: 'relative' }}>
              <Form.Group>
                <Form.Label className="mb-1">Quantity</Form.Label>
                <Form.Control
                  type="number"
                  value={item.approx_quantity}
                  onChange={(e) => handleItemChange(index, 'approx_quantity', e.target.value)}
                  isInvalid={stepSubmitted && !item.approx_quantity}
                  style={{ paddingRight: '40px' }}
                />
                {item.quantity_unit && (
                  <span
                    style={{
                      position: 'absolute',
                      top: '33px',
                      right: '10px',
                      background: '#f0f0f0',
                      borderRadius: '4px',
                      padding: '2px 6px',
                      fontSize: '0.75rem',
                      color: '#555',
                    }}
                  >
                    {item.quantity_unit}
                  </span>
                )}
              </Form.Group>
            </div>

            <div style={{ flex: '0 0 auto', marginTop: '30px' }}>
              {form.items.length > 1 && (
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => removeItem(index)}
                >
                  Remove
                </Button>
              )}
            </div>
          </div>
        </div>
      ))}

      <Button variant="outline-primary" onClick={addItem}>
        + Add Item
      </Button>
    </>
  );
}

PurchaseItemsForm.validate = (form) => {
  return form.items.length > 0 && form.items.every(item =>
    item.product && item.approx_quantity && item.quantity_unit
  );
};

export default PurchaseItemsForm;
